<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="manager" class="bmd-label-floating">Gerente</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="managers"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.manager_user_id">
                                        </model-list-select>
                                        <label v-if="validation.manager_id != ''" id="manager_id-error" class="error" for="manager_id">{{ validation.manager_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="supervisor" class="bmd-label-floating">Supervisor</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="supervisors"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.supervisor_user_id">
                                        </model-list-select>
                                        <label v-if="validation.supervisor_id != ''" id="supervisor_id-error" class="error" for="supervisor_id">{{ validation.supervisor_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="after_sales" class="bmd-label-floating">Pós Venda</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="after_sales"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.after_sale_user_id">
                                        </model-list-select>
                                        <label v-if="validation.after_sale_id != ''" id="after_sale_id-error" class="error" for="after_sale_id">{{ validation.after_sale_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="salesmans" class="bmd-label-floating">Vendedores</label>
                                        <multi-select 
                                            v-model="form.salesmans" 
                                            :options="salesmans"
                                            :multiple="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Selecione os vendedores"
                                            label="name"
                                            track-by="name"
                                            value="id">
                                        </multi-select>
                                        <label v-if="validation.salesman_id != ''" id="salesman_id-error" class="error" for="salesman_id">{{ validation.salesman_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <goal-grid 
                                    gridTitle="Metas para a equipe"
                                    :items="form.goals"
                                    @add="addGoal"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'teams.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import validation from '@/services/validations.service';
    import GoalGrid from '@/views/Goals/Grid';

    export default {
        components : {
            GoalGrid,
        },
        data() {
            return {
                after_sales: [],
                form: {
                    after_sale_user_id: '',
                    manager_user_id: '',
                    name: '',
                    salesmans: [],
                    supervisor_user_id: '',
                    goals:[{}]
                },
                managers: [],
                salesmans: [],
                supervisors: [],
                validation: {
                    after_sale_user_id: '',
                    manager_user_id: '',
                    name: '',
                    salesmans: '',
                    supervisor_user_id: ''
                }
            };
        },
        created() {
            var self = this;

            self.getManagers();
        },
        methods: {
            addGoal( item ){
                this.form.goals.push( item );
            },
            async getAfterSales() {
                var self = this;

                const response = self.$store.dispatch('users/getAfterSales');

                response.then(function (_users) {
                    self.after_sales = _users;
                    self.after_sales.unshift({id: '', name: 'Escolha um Pós Venda'});
                    
                    self.getSalesman();
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'teams.index'});
                });
            },
            async getManagers() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('users/getManagers');

                response.then(function (_users) {
                    self.managers = _users;
                    self.managers.unshift({id: '', name: 'Escolha um Gerente'});
                    
                    self.getSupervisors();
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'teams.index'});
                });
            },
            async getSalesman() {
                var self = this;

                const response = self.$store.dispatch('users/getSalesmans');

                response.then(function (_users) {
                    self.salesmans = _users;
                    
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'teams.index'});
                });
            },
            async getSupervisors() {
                var self = this;
                
                const response = self.$store.dispatch('users/getSupervisors');

                response.then(function (_users) {
                    self.supervisors = _users;
                    self.supervisors.unshift({id: '', name: 'Escolha um Supervisor'});
                    
                    self.getAfterSales();
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'teams.index'});
                });
            },
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('teams/add', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Equipe criada com sucesso!");
                        self.$router.push({'name': 'teams.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        if (err.status === 406) {
                            if (err.data.name !== undefined) {
                                self.validation.name = err.data.name[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>
<style scoped>
    .card-title {
        color: #3c4858;
        text-decoration: none;
    }
</style>